// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../../../node_modules/@glennsl/bs-json/src/Json.bs.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as UpdateCampaignPayload from "../entity/UpdateCampaignPayload.bs.js";
import * as AllocationDashboardRepoConfig from "./AllocationDashboardRepoConfig.bs.js";
import * as CreateMandatoryCampaignPayload from "../entity/CreateMandatoryCampaignPayload.bs.js";
import * as FilterZonalClusterCampaignRequest from "../entity/FilterZonalClusterCampaignRequest.bs.js";
import * as UpdateZonalOrClusterCampaignPayload from "../entity/UpdateZonalOrClusterCampaignPayload.bs.js";
import * as CreateZonalOrClusterCampaignApiModel from "../api-model/CreateZonalOrClusterCampaignApiModel.bs.js";
import * as CreateZonalOrClusterCampaignPayloadMapper from "../entity-mapper/CreateZonalOrClusterCampaignPayloadMapper.bs.js";

function fetchAllocationCampaigns(payload, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/campaign/allocation/campaigns?geo_region_id=" + String(payload.geo_region_id) + "&vehicle_id=" + String(payload.vehicle_id);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.FilterAllocationCampaignResponseConverter.execute, result);
                        });
            });
}

function getUserAccessLevel(payload, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/campaign/allocation/user_access_level?email=" + payload;
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.UserTypeResponseConverter.execute, result);
                        });
            });
}

function createMandatoryCampaign(payload, country) {
  var encodedPayload = JSON.stringify(CreateMandatoryCampaignPayload.t_encode(payload));
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/campaign/allocation/campaigns/create";
  return NetworkV2$Catalyst.post(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, encodedPayload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.CreateMandatoryCampaignResponseConverter.execute, result);
                        });
            });
}

function updateMandatoryCampaign(payload, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/campaign/allocation/campaigns/update_status";
  var encodedPayload = JSON.stringify(UpdateCampaignPayload.t_encode(payload));
  return NetworkV2$Catalyst.put(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, encodedPayload, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.UpdateCampaignStatusResponseConverter.execute, result);
                        });
            });
}

function createZonalOrClusterCampaign(payload) {
  var encodedPayload = Json.stringify(CreateZonalOrClusterCampaignApiModel.t_encode(CreateZonalOrClusterCampaignPayloadMapper.execute(payload)));
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/campaign/allocation/campaigns/sub-geo";
  return NetworkV2$Catalyst.post(requestUrl, undefined, encodedPayload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.CreateZonalOrClusterCampaignResponseConverter.execute, result);
                        });
            });
}

function fetchZoneClusterCampaigns(payload, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/campaign/allocation/campaigns/sub-geo/search";
  var encodedPayload = JSON.stringify(FilterZonalClusterCampaignRequest.t_encode(payload));
  return NetworkV2$Catalyst.postV2(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, encodedPayload, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.ZoneClusterCampaignResponseConverter.execute, result);
                        });
            });
}

function updateZoneClusterCampaigns(payload, country) {
  var encodedPayload = JSON.stringify(UpdateZonalOrClusterCampaignPayload.t_encode(payload));
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/campaign/allocation/campaigns/sub-geo";
  return NetworkV2$Catalyst.put(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, encodedPayload, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.UpdateZoneClusterCampaignsResponseConverter.execute, result);
                        });
            });
}

var AllocationDashboardRepo = {
  fetchAllocationCampaigns: fetchAllocationCampaigns,
  getUserAccessLevel: getUserAccessLevel,
  createMandatoryCampaign: createMandatoryCampaign,
  updateMandatoryCampaign: updateMandatoryCampaign,
  createZonalOrClusterCampaign: createZonalOrClusterCampaign,
  fetchZoneClusterCampaigns: fetchZoneClusterCampaigns,
  updateZoneClusterCampaigns: updateZoneClusterCampaigns
};

export {
  AllocationDashboardRepo ,
  
}
/* Config Not a pure module */
